import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { createUpdateId } from '../../utils/updateId';
var transformSurfaceInitToSurfaceState = function transformSurfaceInitToSurfaceState(name, initOptions) {
  return {
    name: name,
    error: undefined,
    fallback: initOptions === null || initOptions === void 0 ? void 0 : initOptions.fallback
  };
};
var transformSurfaceInitializationToClientSurfaceStates = function transformSurfaceInitializationToClientSurfaceStates(surfaces) {
  return new Map(Object.entries(surfaces).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      name = _ref2[0],
      initOptions = _ref2[1];
    return [name, transformSurfaceInitToSurfaceState(name, initOptions)];
  }));
};
var transformSurfaceInitializationToSurfaceByCombinedKey = function transformSurfaceInitializationToSurfaceByCombinedKey(surfaces) {
  return new Map(Object.entries(Object.entries(surfaces).reduce(function (a, _ref3) {
    var _initOptions$surfaceK, _initOptions$surface, _initOptions$surfaceT, _initOptions$surface2, _a$combinedKey, _a$combinedKey2;
    var _ref4 = _slicedToArray(_ref3, 2),
      initOptions = _ref4[1];
    var surfaceKey = (_initOptions$surfaceK = initOptions.surfaceKey) !== null && _initOptions$surfaceK !== void 0 ? _initOptions$surfaceK : (_initOptions$surface = initOptions.surface) === null || _initOptions$surface === void 0 ? void 0 : _initOptions$surface.key;
    var surfaceType = (_initOptions$surfaceT = initOptions.surfaceType) !== null && _initOptions$surfaceT !== void 0 ? _initOptions$surfaceT : (_initOptions$surface2 = initOptions.surface) === null || _initOptions$surface2 === void 0 ? void 0 : _initOptions$surface2.type;
    var combinedKey = buildCombinedKey(surfaceType, surfaceKey);
    var updateId = createUpdateId();
    return _objectSpread(_objectSpread({}, a), {}, _defineProperty({}, combinedKey, {
      updateId: updateId,
      surface: (a === null || a === void 0 || (_a$combinedKey = a[combinedKey]) === null || _a$combinedKey === void 0 ? void 0 : _a$combinedKey.surface) || (initOptions === null || initOptions === void 0 ? void 0 : initOptions.surface),
      isLoading: !(a !== null && a !== void 0 && (_a$combinedKey2 = a[combinedKey]) !== null && _a$combinedKey2 !== void 0 && _a$combinedKey2.surface || initOptions.load === 'PRE')
    }));
  }, {})));
};
export var transformSurfaceInitializationToCombinedKeyByName = function transformSurfaceInitializationToCombinedKeyByName(surfaces) {
  return new Map(Object.entries(surfaces).map(function (_ref5) {
    var _initOptions$surfaceT2, _initOptions$surface3, _initOptions$surfaceK2, _initOptions$surface4;
    var _ref6 = _slicedToArray(_ref5, 2),
      name = _ref6[0],
      initOptions = _ref6[1];
    return [name, buildCombinedKey((_initOptions$surfaceT2 = initOptions.surfaceType) !== null && _initOptions$surfaceT2 !== void 0 ? _initOptions$surfaceT2 : (_initOptions$surface3 = initOptions.surface) === null || _initOptions$surface3 === void 0 ? void 0 : _initOptions$surface3.type, (_initOptions$surfaceK2 = initOptions.surfaceKey) !== null && _initOptions$surfaceK2 !== void 0 ? _initOptions$surfaceK2 : (_initOptions$surface4 = initOptions.surface) === null || _initOptions$surface4 === void 0 ? void 0 : _initOptions$surface4.key)];
  }));
};
var createSurfaceStates = function createSurfaceStates(surfaces) {
  var clientSurfaceStates = transformSurfaceInitializationToClientSurfaceStates(surfaces);
  var surfaceCombinedKeyByName = transformSurfaceInitializationToCombinedKeyByName(surfaces);
  var surfacesByCombinedKey = transformSurfaceInitializationToSurfaceByCombinedKey(surfaces);
  return {
    set: function set(name, state) {
      var surfaceCombinedKey = surfaceCombinedKeyByName.get(name);
      var updateId = createUpdateId();
      if (!surfaceCombinedKey || !clientSurfaceStates.has(name) || !surfacesByCombinedKey.has(surfaceCombinedKey)) {
        throw Error("Tried to update a surface with name ".concat(name, ", but no surface of that name exists. Check your initialization settings"));
      }
      clientSurfaceStates.set(name, {
        name: name,
        fallback: state.fallback,
        error: state.error
      });
      surfacesByCombinedKey.set(surfaceCombinedKey, {
        updateId: updateId,
        surface: state.surface,
        isLoading: state.isLoading
      });
    },
    get: function get(name) {
      try {
        var surfaceCombinedKey = surfaceCombinedKeyByName.get(name);
        var surfaceState = clientSurfaceStates.get(name);
        var surfaceByCombinedKey = surfacesByCombinedKey.get(surfaceCombinedKey);
        if (!surfaceState || !surfaceByCombinedKey) {
          throw Error;
        }
        return _objectSpread(_objectSpread({}, surfaceState), surfaceByCombinedKey);
      } catch (_unused) {
        throw Error("Tried to get surface with name \"".concat(name, "\" but no surface of that name was initialized"));
      }
    },
    isSelected: function isSelected(name, selectors) {
      return !!selectors.find(function (selector) {
        return surfaceCombinedKeyByName.get(selector) === surfaceCombinedKeyByName.get(name);
      });
    }
  };
};
export var createSurfaceStore = function createSurfaceStore(surfaceInitializationOptions) {
  var surfaceStates = createSurfaceStates(surfaceInitializationOptions);
  var subscribers = new Map();
  var updateSubscribers = function updateSubscribers(_ref7) {
    var name = _ref7.name;
    var surfaceName = name;
    subscribers.forEach(function (subscriber) {
      return updateSubscriber(subscriber, surfaceName);
    });
  };
  var updateSubscriber = function updateSubscriber(subscriber, surfaceName) {
    var _subscriber = _slicedToArray(subscriber, 2),
      subscription = _subscriber[0],
      selectors = _subscriber[1];
    if (!selectors || surfaceStates.isSelected(surfaceName, selectors)) {
      var state = surfaceStates.get(surfaceName);
      if (state) {
        subscription(state);
      }
    }
  };
  var subscribe = function subscribe() {
    for (var _len = arguments.length, subscriber = new Array(_len), _key = 0; _key < _len; _key++) {
      subscriber[_key] = arguments[_key];
    }
    var subscription = subscriber[0],
      selectors = subscriber[1],
      options = subscriber[2];
    subscribers.set(subscriber, subscriber);
    if (options !== null && options !== void 0 && options.updateOnSubscribe) {
      selectors === null || selectors === void 0 || selectors.forEach(function (selector) {
        updateSubscriber([subscription, [selector]], selector);
      });
    }
    return function () {
      return subscribers.delete(subscriber);
    };
  };
  var setState = function setState(newSurfaceState, callback) {
    var surfaceName = newSurfaceState.name;
    surfaceStates.set(surfaceName, newSurfaceState);
    callback();
  };
  var update = function update(surfaceName, surfaceState) {
    var previousSurfaceState = surfaceStates.get(surfaceName);
    var partialSurfaceState = typeof surfaceState === 'function' ? surfaceState(surfaceStates.get(surfaceName)) : surfaceState;
    var newSurfaceState = _objectSpread(_objectSpread({}, previousSurfaceState), partialSurfaceState);
    setState(newSurfaceState, function () {
      updateSubscribers(newSurfaceState);
    });
  };
  var getCurrentSurfaceState = function getCurrentSurfaceState(surfaceName) {
    return surfaceStates.get(surfaceName);
  };
  var getCurrentSurfaceStateFromKeys = function getCurrentSurfaceStateFromKeys(surfaceType, surfaceKey) {
    return surfaceStates.get(buildCombinedKey(surfaceType, surfaceKey));
  };
  var getSurfaceInitializationOptions = function getSurfaceInitializationOptions(surfaceName) {
    var surfaceOptions = surfaceInitializationOptions === null || surfaceInitializationOptions === void 0 ? void 0 : surfaceInitializationOptions[surfaceName];
    if (!surfaceOptions) {
      throw Error("Tried to get surface initializations options for \"".concat(surfaceName, "\" but no surface of that name was initialized"));
    }
    return surfaceOptions;
  };
  var getSurfaces = function getSurfaces() {
    return surfaceInitializationOptions;
  };
  return {
    getSurfaceInitializationOptions: getSurfaceInitializationOptions,
    getCurrentSurfaceState: getCurrentSurfaceState,
    getCurrentSurfaceStateFromKeys: getCurrentSurfaceStateFromKeys,
    getSurfaces: getSurfaces,
    update: update,
    subscribe: subscribe
  };
};
function buildCombinedKey(SurfaceType, surfaceKey) {
  return "".concat(SurfaceType, ",").concat(surfaceKey);
}